(function(window) {
  'use strict';

  function isStandardStickerFamily(requestedRecipeId, flags) {
    flags = flags || {};
    return requestedRecipeId === '' &&
      !flags.isLabelFamily &&
      !flags.hasLabelFamilyTag &&
      !flags.isStickerSheets &&
      !flags.isFixedShape &&
      !flags.isPrintFixed &&
      !flags.isMagnet &&
      !flags.isTemporaryTattoos &&
      !flags.isCling &&
      !flags.isCoaster;
  }

  function resolve(isStandardSticker, search, laminationEnabled) {
    if (!isStandardSticker) return null;

    var params;
    try {
      params = new URLSearchParams(search || '');
    } catch (error) {
      return null;
    }

    var result = {
      rawMaterial: params.has('material') ? String(params.get('material') || '').trim().toLowerCase() : null,
      rawShape: params.has('shape') ? String(params.get('shape') || '').trim().toLowerCase() : null,
      shape: null,
      rawWidth: params.has('width') ? String(params.get('width') || '').trim() : null,
      rawHeight: params.has('height') ? String(params.get('height') || '').trim() : null,
      dimensions: null,
      rawFinish: params.has('finish') ? String(params.get('finish') || '').trim().toLowerCase() : null,
      finish: null,
      rejected: []
    };

    // Standard Sticker material is Shopify product identity, not a
    // customer-editable calculator option. Keep ZUG_MAT:* authoritative.
    if (result.rawMaterial !== null) {
      result.rejected.push('material');
    }

    if (result.rawShape !== null) {
      var shapes = {
        custom: { key: 'custom', label: 'Custom Shape' },
        round: { key: 'round', label: 'Round' },
        square: { key: 'square', label: 'Square' },
        rounded_corners: { key: 'rounded_corners', label: 'Rounded Corners' }
      };
      result.shape = shapes[result.rawShape] || null;
      if (!result.shape) result.rejected.push('shape');
    }

    if (result.rawWidth !== null || result.rawHeight !== null) {
      var decimalInches = /^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/;
      var width = decimalInches.test(result.rawWidth || '') ? Number(result.rawWidth) : NaN;
      var height = decimalInches.test(result.rawHeight || '') ? Number(result.rawHeight) : NaN;
      if (Number.isFinite(width) && Number.isFinite(height) &&
          width >= 0.25 && width <= 48 &&
          height >= 0.25 && height <= 48) {
        result.dimensions = {
          widthIn: width,
          heightIn: height,
          enteredWidth: result.rawWidth,
          enteredHeight: result.rawHeight
        };
      } else {
        result.rejected.push('dimensions');
      }
    }

    if (result.rawFinish !== null) {
      var finishAliases = {
        laminated: { key: 'laminated', label: 'Laminated' },
        unlaminated: { key: 'non_lam', label: 'Non-Laminated' },
        non_lam: { key: 'non_lam', label: 'Non-Laminated' }
      };
      result.finish = laminationEnabled ? (finishAliases[result.rawFinish] || null) : null;
      if (!result.finish) result.rejected.push('finish');
    }

    return result;
  }

  window.ZUG_STICKER_URL_PRESETS = {
    isStandardStickerFamily: isStandardStickerFamily,
    resolve: resolve
  };
})(window);
